<sd-modal>
  <div class="wrapper">
    <h4 class="title">Удаление карты</h4>
    <div class="content">
      Вы хотите удалить сохраненную карту? Так же она будет недоступна при выборе способа оплаты.
    </div>
    <button sdButton class="remove-button" type="critical" size="s" (click)="remove()">Удалить</button>
  </div>
</sd-modal>
